import { DEFAULT_MAP_CONFIG, deserializeMapConfig, MapImageConfig } from 'features/WarehouseMapConstructor/model/mapConfigSerialization';
import { deserializeShapes } from 'features/WarehouseMapConstructor/model/serialization';
import { Shape } from 'features/WarehouseMapConstructor/model/types';
import { sortShapesByZIndex } from 'features/WarehouseMapConstructor/utils/helpers/shapeZIndex';

interface Args {
  shapesConfig?: Nullable<string>;
  mapConfig?: Nullable<string>;
}

interface BookingFloorMapData {
  shapes: Shape[];
  imageTransform: MapImageConfig;
  labelFontSize: number;
}

export const hasBookingFloorMap = (shapesConfig?: Nullable<string>): boolean => deserializeShapes(shapesConfig).length > 0;

export const getBookingFloorMapData = ({ shapesConfig, mapConfig }: Args): BookingFloorMapData => {
  const floorMapConfig = deserializeMapConfig(mapConfig);

  return {
    shapes: sortShapesByZIndex(deserializeShapes(shapesConfig)),
    imageTransform: floorMapConfig.image ?? DEFAULT_MAP_CONFIG.image,
    labelFontSize: floorMapConfig.labelFontSize,
  };
};
